'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * KIAO VOICE wordmark image used in the marketing navbar, app navbar, app
 * sidebar, and trial topnav. Centralizes the public asset path and the
 * localized alt text so all call sites stay in sync (single source of truth
 * for the brand asset). Sized via the `.brand-logo` class in ui-kit CSS;
 * pass `className` for context-specific layout tweaks.
 *
 * `'use client'` because of the `useTranslation` for the alt text. Every other
 * caller is itself a client component, so this only ever mattered once a SERVER
 * component rendered it (`/desktop-login`) — and there it is not a warning but
 * a 500: `react-i18next` reaches for `createContext` in the RSC runtime.
 */
export function BrandLogo({ className }: { className?: string }) {
  const { t } = useTranslation('common')
  return (
    <img
      className={className ? `brand-logo ${className}` : 'brand-logo'}
      src="/brand/kiao-voice-logo.png"
      // Intrinsic dimensions of the wordmark PNG. The displayed size comes from
      // the `.brand-logo` CSS (height-based); passing width/height gives the
      // browser the aspect ratio up front so the above-the-fold navbar reserves
      // space and never shifts on load (CLS).
      width={1266}
      height={128}
      alt={t('productName')}
    />
  )
}
